import React from 'react';
import { METHOD_DEFINITIONS } from '../../constants/methods';

export default function MethodPickerPage({ setActiveTab }) {
  return (
    <section className="relative mx-auto max-w-6xl px-6 pb-24 pt-28 text-white lg:px-16">
      <div className="pointer-events-none absolute inset-x-0 top-10 -z-10 h-64 rounded-full bg-gradient-to-r from-[#8b5cf6]/25 via-transparent to-[#ec4899]/25 blur-3xl" />
      <header className="mb-12 max-w-3xl space-y-4">
        <p className="text-sm uppercase tracking-[0.35em] text-white/60">Choose your solver</p>
        <h1 className="text-4xl font-semibold leading-tight md:text-5xl">
          Start a new NumSolve session
        </h1>
        <p className="text-lg text-white/70">
          Pick the kind of problem you’d like to solve and dive into a workspace. Every workspace offers interactive visualizations, 
          step-by-step explanations, and quick access to related resources.
        </p>
      </header>

      <div className="grid gap-8 md:grid-cols-2">
        {METHOD_DEFINITIONS.map((method) => (
          <button
            key={method.id}
            onClick={() => setActiveTab(method.id)}
            className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-white/10 bg-white/5 p-6 text-left shadow-[0_35px_65px_-45px_rgba(76,29,149,0.8)] transition duration-300 hover:-translate-y-1 hover:border-white/30 hover:bg-white/10 hover:shadow-[0_45px_85px_-45px_rgba(236,72,153,0.7)]"
          >
            <div className="flex items-center gap-4">
              <span
                className="flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full text-white shadow-lg"
                style={{ backgroundColor: method.color }}
              >
                {method.icon}
              </span>
              <div>
                <h2 className="text-xl font-semibold text-white">{method.name}</h2>
                <p className="text-lg font-medium text-white/60">{method.description}</p>
              </div>
            </div>
            <div className="mt-8 flex items-center gap-2 text-lg font-semibold text-white/80">
              <span>Open workspace</span>
              <svg
                className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 5l5 5-5 5"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
